import { ReactNode } from "react";
import { styled } from 'styled-components';

interface ButtonProps  {
    href?: string;
    onClick?: (e: React.MouseEvent) => void;
    content: string | ReactNode;
    newTab?: boolean;
    width?: string | number;
};

const Primary = styled.a<{ width?: string | number }>`
    background-color: #1385C8;
    text-decoration: none;
    color: #FFFFFF;
    font-family: Pearl;
    font-size: 24px;
    font-weight: 400;
    line-height: 36px;
    padding: 16px 60px;
    border-radius: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    ${({ width }) => width ? `width: ${width};` : ''}
    z-index: 20;

    &:hover {
        background: linear-gradient(#1385C8, #34AFCE, #45B9AE);
        color: #FFFFFF;
    }
`;

const Secondary = styled.a<{ width?: string | number }>`
    background-color: #FFFFFF;
    border: solid 1px #5199E0;
    text-decoration: none;
    color: #101720;
    font-family: Pearl;
    font-size: 24px;
    font-weight: 400;
    line-height: 36px;
    padding: 16px 40px;
    border-radius: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    ${({ width }) => width ? `width: ${width};` : ''}
    z-index: 20;

    &:hover {
        color: #101720;
    }
`;

export const PrimaryButton = (props: ButtonProps) => {
    const newTabProps = props.newTab ? {
        target: '_blank',
        rel: 'noopener noreferrer'
    } : {};

    return (
        <Primary href={props.href} {...newTabProps} width={props.width} onClick={props.onClick}>
            {props.content}
        </Primary>
    );
};

export const SecondaryButton = (props: ButtonProps) => {
    const newTabProps = props.newTab ? {
        target: '_blank',
        rel: 'noopener noreferrer'
    } : {};

    return (
        <Secondary href={props.href} {...newTabProps} width={props.width} onClick={props.onClick}>
            {props.content}
        </Secondary>
    );
};
